export default {
  path: '/regioes',
  name: 'Regions.index',
  component: () => import(/* webpackChunkName: "Regions.index" */ './pages/Index.vue')
}